import { Pipe, PipeTransform } from '@angular/core';

/**
 * Se usa para truncar una cadena de texto
 * @example
 * <div> {{miVariable | truncate : 12 : false}}</div>
 * @tutorial
 * https://stackoverflow.com/a/46455994
 */
@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  /**
   * @param value Cadena de texto a truncar
   * @param limit Número de caracteres. Por defecto 25
   * @param completeWords True: no parte la última palabra. Por defecto true
   * @param ellipsis Carácter a añadir al final. Por defecto ...
   */
  transform(value: string, limit = 25, completeWords = true, ellipsis = '…') {
    if (value !== undefined && value !== null && value.length > limit) {
      if (completeWords) {
        limit = value.substr(0, limit).lastIndexOf(' ');
      }
      return `${value.substr(0, limit)}${ellipsis}`;
    }
    return value;
  }

}
